<template>
  <div class="group-management-container">
    <div class="menu-router-container">
      <third-router-nav />
      <div class="back-btn" @click="goBack">
        <img src="https://retail-terminal-management.oss-cn-shanghai.aliyuncs.com/terminal-admin/store-back.png">
        <span>返回</span>
      </div>
    </div>
    <div class="detail-info-basic-container">
      <Title title="基本信息" :space="false" />
      <div class="detail-info-basic-box">
        <div class="detail-info-basic-box-info">
          <div class="detail-info-basic-box-head">
            <img src="" class="head">
          </div>
          <div class="detail-info-basic-box-content">
            <span class="name">姓名</span>
            <p class="phone">
              13390102236
            </p>
          </div>
        </div>
        <div class="detail-info-basic-box-data">
          <div class="two-box">
            <div>
              <detail-bar title="邮箱" content="10,000.00" :bold="true" />
            </div>
            <div>
              <detail-bar title="所属公司" content="87873(缺)" :bold="true" />
            </div>
          </div>
          <div class="one-box">
            <detail-bar title="昵称" content="dataForm.nickName" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ThirdRouterNav from '@/components/dashboard/ThirdRouterNav'
import Title from '@/components/title/Title'
import DetailBar from '@/components/bar/DetailBar'
export default {
  components: {
    ThirdRouterNav,
    Title,
    DetailBar
  },
  data() {
    return {
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
  .group-management-container {
    background-color: #fff;
    width: 100%;
    flex: 1;
    .menu-router-container {
      display: flex;
      justify-content: space-between;
      background-color: #ebeeef;
      .back-btn {
        width: 80px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #DFE0E3;
        margin-left: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 14px;
          height: 14px
        }
        span {
          margin-left: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #1F2329;
        }
      }
      .simple-menu-right {
        width: 200px;
        margin-right: 40px;
        display: flex;
        justify-content: flex-end;
        .el-button {
          height: 32px;
          line-height: 32px;
          padding: 0 10px;
          margin-left: 15px;
        }
      }
    }
    .detail-info-basic-container {
      width: 836px;
      margin: 0 auto;
      padding: 20px;
      .detail-info-basic-box {
        margin-top: 21px;
        .detail-info-basic-box-info {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .detail-info-basic-box-head {
            position: relative;
            .head {
              width: 64px;
              height: 64px;
              border-radius: 32px;
            }
            .sex {
              width: 22px;
              height: 22px;
              position: absolute;
              left: 42px;
              bottom: 0px;
            }
          }
          .detail-info-basic-box-content {
            margin-left: 12px;
            .name {
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #1F2329;
            }
            .phone {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #646A73;
              margin-top: 2px;
            }
          }
        }
        .detail-info-basic-box-data {
          margin-top: 24px;
          .two-box {
            display: flex;
            justify-content: space-between;
            >div {
              width: calc(50% - 6px);
            }
          }
          .one-box {
            .tag {
              .title {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #646A73;
                line-height: 22px;
                margin-bottom: 8px;
              }
            }
          }
        }
      }
    }
  }
</style>
